export default "<!-- Todo delete or improve in the future -->\r\n"